import React, { PureComponent, Children } from 'react'
import styles from './style.module.less'
const types = {
  del: '#999',
  danger: '#ff5c5c',
  primary: '#448afc'
}
const Item = ({ style = {}, type, children, ...rest }) => {
  return (
    <span
      style={{ color: types[type], ...style }}
      {...rest}
      className={styles.item}
    >
      {children}
    </span>
  )
}
class Operation extends PureComponent {
  static defaultProps = {
    separator: ' '
  }
  getActionItem = (children, separator) => {
    const items = []
    Children.forEach(children, item => {
      if (item && item.type === Item) {
        items.push(item)
      }
    })
    const len = items.length
    const _items = []
    items.forEach((item, i) => {
      _items.push(item)
      if (i < len - 1) {
        _items.push(
          <span
            className={styles.separator}
            key={'separator-' + i}
            style={{ margin: '0 4px' }}
          >
            {separator}
          </span>
        )
      }
    })
    return _items
  }

  render() {
    const { separator, children, ...rest } = this.props
    return <span {...rest}>{this.getActionItem(children, separator)}</span>
  }
}
Operation.Item = Item
export default Operation
